module.exports = __webpack_public_path__ + "media/images/projects/9-dashboard-681e918073e18cf19e23218413aca9d0.jpg";